import React, { useEffect, useState } from 'react';

type ToastType = 'success' | 'error';

type ToastRequest = {
  message: string;
  type?: ToastType;
  durationMs?: number;
};

const TOAST_EVENT = 'k2_toast';
const DEFAULT_DURATION = 4000;

export const showToast = (message: string, options: Omit<ToastRequest, 'message'> = {}) => {
  if (typeof window === 'undefined') return;
  const detail: ToastRequest = {
    message,
    type: options.type || 'error',
    durationMs: typeof options.durationMs === 'number' ? options.durationMs : DEFAULT_DURATION
  };
  window.dispatchEvent(new CustomEvent<ToastRequest>(TOAST_EVENT, { detail }));
};

export const ToastHost: React.FC = () => {
  const [toast, setToast] = useState<ToastRequest | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<ToastRequest>;
      setToast(customEvent.detail);

      const duration =
        typeof customEvent.detail?.durationMs === 'number'
          ? customEvent.detail.durationMs
          : DEFAULT_DURATION;

      if (duration > 0) {
        window.setTimeout(() => setToast(null), duration);
      }
    };

    window.addEventListener(TOAST_EVENT, handler);
    return () => window.removeEventListener(TOAST_EVENT, handler);
  }, []);

  if (!toast) return null;

  return (
    <div className="fixed top-4 right-4 z-[200]">
      <div
        className={`rounded-lg px-4 py-2 text-xs font-black uppercase tracking-widest shadow-lg border ${
          toast.type === 'success'
            ? 'bg-green-600 text-white border-green-500'
            : 'bg-red-600 text-white border-red-500'
        }`}
      >
        {toast.message}
      </div>
    </div>
  );
};
